/* Word-by-word reveal for the statement, plus parallax on the floating images.

   Same idea as the homepage promise section, tuned to start sooner: the
   observer fires a screen early and the words are staggered tighter. */
(() => {
  const splitWords = (intro) => {
    if (intro.dataset.faSplit) return;

    const walker = document.createTreeWalker(intro, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    let index = 0;

    nodes.forEach((node) => {
      if (!node.nodeValue.trim()) return;

      const frag = document.createDocumentFragment();
      node.nodeValue.split(/(\s+)/).forEach((part) => {
        if (!part) return;
        if (!part.trim()) {
          frag.appendChild(document.createTextNode(part));
          return;
        }
        const span = document.createElement('span');
        span.className = 'fa__w';
        span.style.setProperty('--fa-wi', index++);
        span.textContent = part;
        frag.appendChild(span);
      });
      node.parentNode.replaceChild(frag, node);
    });

    // Inline images join the queue so they arrive with the words around them.
    intro.querySelectorAll('img').forEach((img) => {
      img.classList.add('fa__w');
      img.style.setProperty('--fa-wi', index++);
    });

    intro.dataset.faSplit = 'true';
  };

  const setupIntro = (root) => {
    const intro = root.querySelector('[data-fa-intro]');
    if (!intro) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      intro.setAttribute('data-fa-in', '');
      return;
    }

    splitWords(intro);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          intro.setAttribute('data-fa-in', '');
          observer.disconnect();
        });
      },
      // Starts as it comes into reach rather than once a fifth is on screen.
      { threshold: 0, rootMargin: '0px 0px -12% 0px' }
    );
    observer.observe(intro);

    // Never leave the words invisible if the observer does not fire.
    setTimeout(() => intro.setAttribute('data-fa-in', ''), 1200);
  };

  const init = (root) => {
    if (root.dataset.faReady) return;
    root.dataset.faReady = 'true';

    setupIntro(root);

    const decor = root.querySelector('.fa__decor');
    if (!decor) return;

    let frame = 0;
    let onScreen = true;

    const measure = () => {
      frame = 0;
      const viewport = window.innerHeight || 1;
      const top = root.getBoundingClientRect().top;
      root.style.setProperty('--fa-scroll', `${Math.round(viewport - top)}px`);
    };

    const schedule = () => {
      if (frame || !onScreen) return;
      frame = requestAnimationFrame(measure);
    };

    /* Flagged when far away rather than when near, so a failed or slow
       observer leaves the section drifting exactly as it does on screen. */
    new IntersectionObserver(
      ([entry]) => {
        onScreen = entry.isIntersecting;
        root.toggleAttribute('data-fa-far', !onScreen);
        if (onScreen) schedule();
      },
      { rootMargin: '100% 0px' }
    ).observe(root);

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    measure();
  };

  const scan = (scope) => scope.querySelectorAll('[data-fa]').forEach(init);

  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
